import { Flex, Modal, Table } from "@mantine/core";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import TableDeleteButton from "../../common/Buttons/TableDeleteButton";
import CustomPagination from "../../common/CustomPagination";
import AreYouSureModal from "../../common/Modals/AreYouSureModal";
import styled from "styled-components";
import { Role } from "../../../types/types";
import { deleteNotification } from "../../../utils/useNotification";
import TableEditButton from "../../common/Buttons/TableEditButton";
import { deleteRole, getRoleList } from "../../../api/roleApi";
import RoleUpdateForm from "./RoleUpdateForm";
import CustomSearchInput from "../../common/Inputs/CustomSearchInput";

const RoleSettingsTable = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [tableData, setTableData] = useState<any>();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [itemToDeleted, setItemToDeleted] = useState<any>();

  //for modal
  const [opened, setOpened] = useState(false);
  const [clickedRole, setClickedRole] = useState<any>();
  const [isUpdated, setIsUpdated] = useState<boolean>(false);

  //for filters
  const [searchedName, setSearchedName] = useState<any>();

  const getTableData = async () => {
    try {
      const { data }: any = await getRoleList({
        pageNumber: page,
        limit: limit,
        name: searchedName,
      });
      setTableData(data?.data);
      setPage(data?.meta?.page);
      setLimit(data?.meta?.limit);
      setTotalPages(data?.meta?.totalPages);
      setTotalItems(data?.meta?.total);
    } catch (error) {}
  };

  const handleDeleteClick = async (id: string) => {
    try {
      const { data }: any = await deleteRole({ id });
      deleteNotification(data?.success);
      const { data: updatedList }: any = await getRoleList({
        pageNumber: page,
        limit: limit,
      });
      setTableData(updatedList?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (page) {
      getTableData();
    }
  }, [page, searchedName]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            overflowY: "auto",
            minHeight: "422px",
            width: "100%",
            border: "1px solid #D1D5DB",
            borderRadius: "6px",
          }}
        >
          <Flex p={"12px 16px"} justify={"space-between"}>
            <CustomSearchInput
              value={searchedName}
              w={220}
              placeholder="Rol Adı"
              onChange={(event: any) => {
                setPage(1);
                setSearchedName(event.currentTarget.value);
              }}
            />
          </Flex>
          <Table
            style={{
              borderCollapse: "separate",
            }}
            verticalSpacing="sm"
          >
            <Table.Thead
              style={{
                background: "#EEF2FF",
              }}
            >
              <Table.Tr>
                <StyledTableTh>Rol İsmi</StyledTableTh>
                <StyledTableTh>Açıklama</StyledTableTh>
                <StyledTableTh>Gerekli Skiller</StyledTableTh>
                <StyledTableTh></StyledTableTh>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {tableData?.map((role: Role) => (
                <StyledTableTr
                  // onClick={() => {
                  //   navigate(`${location?.pathname}/${role?._id}`);
                  // }}
                  style={{
                    color: "#111827",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                  key={role?._id}
                >
                  <Table.Td style={{ width: "30%" }}>{role?.name}</Table.Td>
                  <Table.Td style={{ width: "30%" }}>
                    {role?.description}
                  </Table.Td>
                  <Table.Td style={{ width: "30%" }}>
                    {!role?.requiredSkills || role.requiredSkills.length === 0
                      ? "Yetenek Bilgisi Yoktur"
                      : role.requiredSkills.length > 1
                      ? "Birden Fazla"
                      : role.requiredSkills[0].name}
                  </Table.Td>
                  <Table.Td style={{ width: "0%" }}>
                    <Flex>
                      {/* <TableInfoButton
                            onClick={(e: any) => {
                              e.stopPropagation();
                              navigate(`${location?.pathname}/${role?._id}`);
                            }}
                          /> */}
                      <TableEditButton
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setClickedRole(role);
                          setOpened(true);
                        }}
                      />
                      <TableDeleteButton
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setItemToDeleted(role);
                          setOpenDeleteModal(true);
                        }}
                      />
                    </Flex>
                  </Table.Td>
                </StyledTableTr>
              ))}
            </Table.Tbody>
          </Table>
        </div>
        <div
          style={{
            paddingTop: "24px",
          }}
        >
          <CustomPagination
            total={totalPages}
            value={page}
            onChange={setPage}
          />
        </div>
      </div>

      <Modal
        opened={opened}
        title="Rol Bilgisi Düzenleme"
        centered
        onClose={() => {
          setOpened(false);
        }}
        withCloseButton={true}
        keepMounted={false}
        key={clickedRole?._id}
      >
        <RoleUpdateForm
          closeModal={() => setOpened(false)}
          role={clickedRole}
          updateRoleList={getTableData}
        />
      </Modal>
      <AreYouSureModal
        opened={openDeleteModal}
        setOpened={setOpenDeleteModal}
        proccessFunc={() => handleDeleteClick(itemToDeleted._id)}
        title="Rol Sil"
        text="Bu rolü silmek istediğinizden emin misiniz?"
        confirmButtonText="Sil"
        cancelButtonText="Vazgeç"
      />
    </>
  );
};

export default RoleSettingsTable;

const StyledTableTh = styled(Table.Td)`
  color: #4c4c4c;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

const StyledTableTr = styled(Table.Tr)`
  // cursor: pointer;
  // &:hover {
  //   background: #f1f3f5 !important;
  // }
`;
